import React from "react";

import AppHangFreeSessionsScoreView from "@main/pages/Release/views/MetricDetails/AppHangFreeSessions/AppHangFreeSessionsScoreView";
import CrashFreeSessionsScoreView from "@main/pages/Release/views/MetricDetails/CrashFreeSessions/CrashFreeSessionsScoreView";
import EndpointHealthScoreView from "@main/pages/Release/views/MetricDetails/EndpointHealth/EndpointHealthScoreView";
import MttrScoreView from "@main/pages/Release/views/MetricDetails/Mttr/MttrScoreView";
import NetworkSpeedScoreView from "@main/pages/Release/views/MetricDetails/NetworkSpeed/NetworkSpeedScoreView";
import ReleaseHealthScoreView from "@main/pages/Release/views/MetricDetails/ReleaseHealth/ReleaseHealthScoreView";
import ResolutionRateScoreView from "@main/pages/Release/views/MetricDetails/ResolutionRate/ResolutionRateScoreView";
import TestingCoverageScoreView from "@main/pages/Release/views/MetricDetails/TestingCoverage/TestingCoverageScoreView";
import { MetricKeys } from "@main/router/config/routePaths";
import { useParams } from "react-router-dom";

export default function MetricScoreView() {
  const { metricKey } = useParams<{ metricKey: string }>();

  if (metricKey === MetricKeys.testingCoverage) return <TestingCoverageScoreView />;
  if (metricKey === MetricKeys.releaseHealth) return <ReleaseHealthScoreView />;
  if (metricKey === MetricKeys.crashFreeSessions) return <CrashFreeSessionsScoreView />;
  if (metricKey === MetricKeys.appHangFreeSessions) return <AppHangFreeSessionsScoreView />;
  if (metricKey === MetricKeys.resolutionRate) return <ResolutionRateScoreView />;
  if (metricKey === MetricKeys.mttr) return <MttrScoreView />;
  if (metricKey === MetricKeys.endpointHealth) return <EndpointHealthScoreView />;
  if (metricKey === MetricKeys.networkSpeed) return <NetworkSpeedScoreView />;

  return <></>;
}
